var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8097 10.9083C13.3158 10.9083 14.5367 12.1292 14.5367 13.6354L14.5353 14.9959C14.7223 18.3349 12.1506 20 7.38163 20C2.62802 20 0 18.3567 0 15.0436V13.6354C0 12.1292 1.22095 10.9083 2.72707 10.9083H11.8097ZM19.0829 10.9083C20.5891 10.9083 21.81 12.1292 21.81 13.6354L21.8086 14.5927C21.973 17.5879 19.7007 19.0895 15.5472 19.0895C14.9834 19.0895 14.4533 19.062 13.9583 19.0071C14.9341 18.106 15.4561 16.8832 15.4543 15.3381L15.4429 14.9451L15.4457 13.6354C15.4457 12.5489 14.9693 11.5738 14.2139 10.9075L19.0829 10.9083ZM7.27219 0C9.7828 0 11.818 2.03525 11.818 4.54586C11.818 7.05646 9.7828 9.09171 7.27219 9.09171C4.76158 9.09171 2.72634 7.05646 2.72634 4.54586C2.72634 2.03525 4.76158 0 7.27219 0ZM16.3624 1.81805C18.3706 1.81805 19.9985 3.44598 19.9985 5.45414C19.9985 7.4623 18.3706 9.09024 16.3624 9.09024C14.3543 9.09024 12.7263 7.4623 12.7263 5.45414C12.7263 3.44598 14.3543 1.81805 16.3624 1.81805Z",
    fill: "#9488A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.6c15e56e9a5ed7be06f3b9c4dda88ad9.svg";
export { ForwardRef as ReactComponent };